document.addEventListener("DOMContentLoaded", () => {
  console.log("Script loaded")

  const overlay = document.querySelector(".floating-overlay");
  const sellingPlanID = overlay?.getAttribute("data-sellingPlanID");
  const cartDisplayName = overlay?.getAttribute("data-cartDisplayName");
  const cartPlanNote = overlay?.getAttribute("data-cartPlanNote");
  const cartOrderDiscount = overlay?.getAttribute("data-cartOrderDiscount");
  const upsellProductId = overlay?.getAttribute("data-upsellProduct");
  const configuredFreeGiftVariantId = overlay?.getAttribute("data-free-gift-product-variant-id");
  const autoAddFreeGift = overlay?.getAttribute("data-free-gift-auto") === "true";
  const extraDiscountCodes = (overlay?.getAttribute("data-extra-discount-codes") || "")
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
  const freeGiftPopup = document.querySelector("[data-free-gift-popup]");
  const freeGiftVariantSelector = freeGiftPopup?.querySelector("[data-free-gift-variant-selector]");
  const freeGiftConfirm = freeGiftPopup?.querySelector("[data-free-gift-confirm]");
  const freeGiftClose = freeGiftPopup?.querySelector("[data-free-gift-close]");
  let resolveFreeGiftSelection = null;

  // Check if the button exists
  var new_mixAndMatchAtc = document.querySelector(".floating-overlay__atc")

  if (!new_mixAndMatchAtc) {
    console.error("Button with class '.floating-overlay__atc' not found!")
    return
  }

  console.log("Button found:", new_mixAndMatchAtc)

  function usingFreebieTiers() {
    return Array.isArray(window.rebrushMixAndMatchFreebies) && window.rebrushMixAndMatchFreebies.length > 0
  }

  function getCurrentQuantity() {
    return Number.parseInt(document.getElementById("overlay-total-selected")?.textContent, 10) || 0
  }

  function getCurrentFreeGiftVariantId() {
    if (usingFreebieTiers() && typeof window.getRebrushMixAndMatchFreebie === "function") {
      const tier = window.getRebrushMixAndMatchFreebie(getCurrentQuantity())
      return tier?.id ? String(tier.id) : null
    }

    return configuredFreeGiftVariantId || null
  }

  function hasConfiguredFreeGift() {
    return Boolean(freeGiftPopup && getCurrentFreeGiftVariantId())
  }

  function getSelectedFreeGiftVariantId() {
    if (usingFreebieTiers()) return getCurrentFreeGiftVariantId()
    return freeGiftVariantSelector?.value || window.rebrushMixAndMatchFreeGiftVariantId || configuredFreeGiftVariantId || null
  }

  function applyCurrentFreeGiftTier() {
    if (!usingFreebieTiers() || typeof window.getRebrushMixAndMatchFreebie !== "function" || !freeGiftPopup) return

    const tier = window.getRebrushMixAndMatchFreebie(getCurrentQuantity())
    if (!tier) return

    const titleEl = freeGiftPopup.querySelector("[data-free-gift-product-title]")
    if (titleEl) {
      let label = tier.title || ""
      if (tier.variantTitle && tier.variantTitle !== "Default Title") {
        label = label ? `${label} – ${tier.variantTitle}` : tier.variantTitle
      }
      titleEl.textContent = label
    }

    const imageEl = freeGiftPopup.querySelector("[data-free-gift-image]")
    if (imageEl) {
      if (tier.image) {
        imageEl.src = tier.image
        imageEl.alt = tier.imageAlt || tier.title || ""
        imageEl.hidden = false
      } else {
        imageEl.removeAttribute("src")
        imageEl.hidden = true
      }
    }

    if (overlay && tier.id) {
      overlay.setAttribute("data-free-gift-product", "true")
      overlay.setAttribute("data-free-gift-product-variant-id", String(tier.id))
    }
  }

  function closeFreeGiftPopup(selectedVariantId = null) {
    if (freeGiftPopup) {
      freeGiftPopup.setAttribute("aria-hidden", "true")
    }

    if (resolveFreeGiftSelection) {
      if (!selectedVariantId) {
        window.rebrushMixAndMatchFreeGiftDeclined = true
      }

      resolveFreeGiftSelection(selectedVariantId)
      resolveFreeGiftSelection = null
    }
  }

  function requestFreeGiftVariantId() {
    if (autoAddFreeGift) {
      return Promise.resolve(configuredFreeGiftVariantId || null)
    }

    if (!hasConfiguredFreeGift()) {
      return Promise.resolve(null)
    }

    if (window.rebrushMixAndMatchFreeGiftVariantId) {
      const currentId = getCurrentFreeGiftVariantId()

      if (!usingFreebieTiers() || (currentId && String(window.rebrushMixAndMatchFreeGiftVariantId) === String(currentId))) {
        return Promise.resolve(currentId || window.rebrushMixAndMatchFreeGiftVariantId)
      }

      window.rebrushMixAndMatchFreeGiftVariantId = null
      window.rebrushMixAndMatchFreeGiftDeclined = false
    }

    if (window.rebrushMixAndMatchFreeGiftDeclined) {
      return Promise.resolve(null)
    }

    applyCurrentFreeGiftTier()
    freeGiftPopup.setAttribute("aria-hidden", "false")

    return new Promise((resolve) => {
      resolveFreeGiftSelection = resolve
    })
  }

  if (freeGiftConfirm) {
    freeGiftConfirm.addEventListener("click", () => {
      const selectedVariantId = getSelectedFreeGiftVariantId()
      window.rebrushMixAndMatchFreeGiftVariantId = selectedVariantId
      window.rebrushMixAndMatchFreeGiftDeclined = false
      closeFreeGiftPopup(selectedVariantId)
    })
  }

  if (freeGiftClose) {
    freeGiftClose.addEventListener("click", () => {
      closeFreeGiftPopup()
    })
  }

  if (freeGiftPopup) {
    freeGiftPopup.addEventListener("click", (event) => {
      if (event.target === freeGiftPopup) {
        closeFreeGiftPopup()
      }
    })
  }

  var items = {}
  var cartItems = []
  var quantitySelector = document.querySelectorAll(".QuantitySelector__CurrentQuantity")

  console.log("Found quantity selectors:", quantitySelector.length)

  quantitySelector.forEach((elem) => {
    console.log("Setting up observer for:", elem)

    // Make sure the element has a dataset.sku
    if (!elem.dataset.sku) {
      console.warn("Element missing data-sku attribute:", elem)
      return
    }

    observeElement(elem, "value", (oldValue, newValue) => {
      var isAboPage = false
      var packageSize, pricePerMeal

      items[elem.dataset.sku] = Number.parseInt(newValue)
      console.log("Updated items:", items)
      updateTotals();
    })
  })



  const fullUrl = window.location.href;

  if (!fullUrl.includes('transactionId')) {

    // Add click event listener
    new_mixAndMatchAtc.addEventListener("click", async (e) => {

      const text = new_mixAndMatchAtc.querySelector('.floating-overlay__atc-text');
      const spinner = new_mixAndMatchAtc.querySelector('.spinner');

      e.preventDefault() // Prevent default action

      const wasFreeGiftDeclinedBeforeRequest = Boolean(window.rebrushMixAndMatchFreeGiftDeclined)
      const freeGiftVariantId = await requestFreeGiftVariantId()

      if (hasConfiguredFreeGift() && !freeGiftVariantId && !wasFreeGiftDeclinedBeforeRequest) {
        if (text) text.style.display = 'block';
        if (spinner) spinner.style.display = 'none';
        return
      }

      if (text) text.style.display = 'none';
      if (spinner) spinner.style.display = 'block';

      const boxSizesID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-boxSizesID")
      const discountID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-discountID")
      const discountCode = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-discountCode")

      const discountCodes = []

      // Add the primary discount code from the selected plan
      if (discountCode) {
        discountCodes.push(discountCode)
      }

      discountCodes.push("FREE SHIPPING")
      discountCodes.push(...extraDiscountCodes)

      // Remove duplicates in case the primary code is already "STRONGHABITSPLAN"
      const uniqueDiscountCodes = [...new Set(discountCodes)]

      console.log("Button clicked!    ", boxSizesID)
      const myHeaders = new Headers()
      myHeaders.append("Accept", "application/json")
      myHeaders.append("Content-Type", "application/json")

      const raw = JSON.stringify({
        boxSizeId: boxSizesID,
        productVariants: Object.entries(items).map(([id, qty]) => ({
          shopifyId: Number(id),
          quantity: qty,
        })),
        quantity: 1,
        sellingPlanShopifyId: Number(sellingPlanID),
        discountId: discountID,
      })

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      }

      const txnId = await createTransaction(requestOptions)

      if (txnId) {
        console.log("---- JACKPOT:", txnId)
        


        // Clear cartItems array before adding new items
        cartItems = []
        const bundleProperties = {
          _bundleId: txnId,
          __cartDisplayName: cartDisplayName,
          ...(cartPlanNote && { __cartPlanNote: cartPlanNote }),
          ...(cartOrderDiscount && { __cartOrderDiscount: cartOrderDiscount }),
          ...(upsellProductId && { __linked_upsell: upsellProductId }),
        }

        // Only add items with quantity > 0
        Object.keys(items).forEach((item) => {
          if (items[item] > 0) {
            cartItems.push({
              id: item,
              quantity: items[item],
              selling_plan: Number(sellingPlanID),
              properties: bundleProperties,
            })
          }
        })

        if (freeGiftVariantId && !autoAddFreeGift) {
          cartItems.push({
            id: Number(freeGiftVariantId),
            quantity: 1,
            properties: { ...bundleProperties },
          })
        }

        console.log("Cart items to add:", cartItems)

        if (cartItems.length === 0) {
          console.warn("No items to add to cart")
          return
        }

        try {

          if (upsellProductId){
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: upsellProductId,
                quantity: 1,
                properties: { _is_free_cart_upsell: true },
              }),
            })
          }

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: cartItems,
            }),
          })

          if (!response.ok) {
            throw new Error("Failed to add items to cart")
          }

          // Added separately so a sold-out gift doesn't block the plan itself
          if (freeGiftVariantId && autoAddFreeGift) {
            const giftResponse = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [{ id: Number(freeGiftVariantId), quantity: 1, properties: { ...bundleProperties } }],
              }),
            })

            if (!giftResponse.ok) {
              console.warn("Free gift could not be added:", await giftResponse.text())
            }
          }

          window.rebrushMixAndMatchFreeGiftVariantId = null
          window.rebrushMixAndMatchFreeGiftDeclined = false

 

          if (uniqueDiscountCodes.length > 0) {
            console.log("Applying discount codes:", uniqueDiscountCodes)
            if (extraDiscountCodes.length > 0) {
              await applyDiscountCodesTogether(uniqueDiscountCodes)
            } else {
              await tryDiscountCodes(uniqueDiscountCodes)
            }
          } else {
            // No discount code, just go to cart
            //window.location.href = "/cart"
          }

          const res = await response.json()
          console.log("Successfully added to cart:", res)

          document.dispatchEvent(new CustomEvent("theme:loading:end"))

          res.items.forEach((item) => {
            document.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  variant: item.variant_id,
                  quantity: item.quantity,
                },
              }),
            )
          })
        } catch (error) {
          console.error("Error:", error)
          document.dispatchEvent(new CustomEvent("theme:loading:end"))
        }
      }

      if (text) text.style.display = 'block';
      if (spinner) spinner.style.display = 'none';
    })
  } else {

    new_mixAndMatchAtc.addEventListener("click", async (e) => {
      const text = new_mixAndMatchAtc.querySelector('.floating-overlay__atc-text');
      const spinner = new_mixAndMatchAtc.querySelector('.spinner');

      if (text) text.style.display = 'none';
      if (spinner) spinner.style.display = 'block';
      e.preventDefault() // Prevent default action

      const boxSizesID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-boxSizesID")
      const discountID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-discountID")

      console.log("Button clicked!    ", boxSizesID)

      var tempHeader = "Bearer " + params.token

      const myHeaders = new Headers()
      myHeaders.append("Authorization", tempHeader)
      myHeaders.append("Accept", "application/json")
      myHeaders.append("Content-Type", "application/json")




      const raw = JSON.stringify({
        id: params.transactionId,
        items: Object.entries(items)
          .filter(([_, qty]) => qty > 0)
          .map(([id, qty]) => ({
            productVariantShopifyId: Number(id),
            quantity: qty,
          })),
        discountId: discountID,
        boxSizeId: boxSizesID,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      }

      const txnId = await updateSubscription(requestOptions)

      if (txnId) {
        console.log("---- JACKPOT:", txnId)
        
        if (window.returnUrl) {
          window.location.href = window.returnUrl;
        } else {
          window.location.href = "/account"
        }
      }
    })
  }

})  

// Make sure you have the observeElement function defined
function observeElement(element, property, callback, delay = 0) {
  const elementPrototype = Object.getPrototypeOf(element)
  if (elementPrototype.hasOwnProperty(property)) {
    const descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property)
    Object.defineProperty(element, property, {
      get: function () {
        return descriptor.get.apply(this, arguments)
      },
      set: function () {
        const oldValue = this[property]
        descriptor.set.apply(this, arguments)
        const newValue = this[property]
        if (typeof callback == "function") {
          setTimeout(callback.bind(this, oldValue, newValue), delay)
        }
        return newValue
      },
    })
  }
}

const bundleNanoIdRequests = {}

async function getBundleNanoId(bundleId) {
  if (!bundleNanoIdRequests[bundleId]) {
    bundleNanoIdRequests[bundleId] = fetch(
      `https://api.loopsubscriptions.com/storefront/2023-10/bundle/${encodeURIComponent(bundleId)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        redirect: "follow",
      }
    )
      .then(async (response) => {
        const result = await response.json()

        if (!response.ok) {
          throw new Error(result?.message || `Failed to fetch bundle details: ${response.status}`)
        }
        const nanoId = result?.data?.nanoId || result?.data?.id
        if (!nanoId) {
          throw new Error("Loop bundle details response did not include a transaction bundle ID")
        }

        return nanoId
      })
      .catch((error) => {
        delete bundleNanoIdRequests[bundleId]
        throw error
      })
  }

  return bundleNanoIdRequests[bundleId]
}

async function createTransaction(requestOptions) {
  try {
    // The transaction endpoint expects Loop's nanoId, not the configured bundle ID.
    const overlay = document.querySelector(".floating-overlay");
    const bundleId = overlay?.getAttribute("data-bundleID");

    if (!bundleId) {
      console.error("No bundle ID found on .floating-overlay");
      return;
    }

    const bundleNanoId = await getBundleNanoId(bundleId)

    const response = await fetch(
      `https://api.loopsubscriptions.com/storefront/2023-10/bundle/${encodeURIComponent(bundleNanoId)}/transaction`,
      requestOptions
    );

    const result = await response.json()
    const txnId = result?.data?.txnId

    console.log("Full Response:", result)
    return txnId

  } catch (error) {
    console.error(error)
  }
}

async function updateSubscription(requestOptions) {
  try {
    const response = await fetch(
      "https://api.loopsubscriptions.com/storefront/2023-10/bundle/transaction/update",
      requestOptions,
    )
    const result = await response.json()
    console.log("Full Response:", result)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

async function applyDiscountToCart(discountCode) {
  try {
    // First, navigate to discount URL to apply it
    const response = await fetch(`/discount/${discountCode}`, {
      method: "GET",
      redirect: "manual",
    })

    // Check if the discount was applied successfully
    if (response.status === 302 || response.status === 200) {
      // Then update cart to reflect changes
      const cartResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            discount_code: discountCode,
          },
        }),
      })

      const updatedCart = await cartResponse.json()
      console.log("Cart updated with discount:", updatedCart)

      return true // Success
    } else {
      console.log(`Discount code ${discountCode} not valid`)
      return false // Failed
    }
  } catch (error) {
    console.error("Error applying discount:", error)
    return false // Failed
  }
}

async function tryDiscountCodes(discountCodes) {
  for (const code of discountCodes) {
    console.log("Trying discount code:", code)
    const success = await applyDiscountToCart(code)

    if (success) {
      console.log(`Successfully applied discount code: ${code}`)
      // Refresh cart display only on success
      location.reload()
      return // Stop trying other codes
    } else {
      console.log(`Failed to apply discount code: ${code}, trying next...`)
      // Continue to next code
    }
  }

  // If no discount codes worked, just go to cart
  console.log("No discount codes worked, redirecting to cart")
  //window.location.href = "/cart"
}

// Applies all codes in one go (tryDiscountCodes stops after the first valid code).
// No reload: the caller dispatches product:added, which refreshes and opens the cart drawer.
async function applyDiscountCodesTogether(discountCodes) {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discount: discountCodes.join(","),
      }),
    })

    const updatedCart = await response.json()
    console.log("Cart updated with discounts:", updatedCart.discount_codes)
  } catch (error) {
    console.error("Error applying discounts:", error)
  }
}
